import * as React from "react";
import {cx} from "emotion";

import "./image-gallery-modal.scss";

import {cs}                    from "../../react/chain-services";
import {fragments}             from "../../react/fragments";
import {OnGlobalKeyDownEscape} from "../browser/global-key-down-escape";
import {ModalState}            from "../modal-service-3/modal-state";

import {ImageGalleryPanel} from "./image-gallery-panel";

export const ImageGalleryModal = (
    {
        initShow=null, hideThumbnails=false,
        backgroundTransparency=0,
        maxWidth=null,
        next: rootNext,
    }
) => cs(

    ["modalState", (_, next) => ModalState({
        initShow,
        next: rootNext,
        // onClose,
        renderUI: next,
    })],
    ({modalState: {transitioning, close, params,}}, next) => fragments(
        <div {...{
            className: cx(
                "image-gallery-modal-5n2",
                {transitioning: transitioning.active},
                transitioning.starting ? "trans-prep" : "trans-in-progress",
                transitioning.toValue  ? "trans-entering" : "trans-exiting",
            ),
            style: {
                "--backgroundTransparency": backgroundTransparency,
                // "--maxWidth": maxWidth,
            }as any,
            onClick: (e) => {
                e.stopPropagation();
                close();
            },
        }}>

            {next()}

            <div {...{
                className: cx("close"),
                onClick: (e) => {
                    e.stopPropagation();
                    close();
                },
                "xd-qa-type": "icon",
                "xd-qa-name": "Default Modal Close",
            }}>
                &times;
            </div>
        </div>,

        OnGlobalKeyDownEscape({
            action: close,
        })
    ),

    ["imgs", ({modalState}, next) => (
        modalState.params?.renderImgs ? (
            modalState.params.renderImgs(next)
        ) : (
            next({
                value: modalState.params.imgs,
            })
        )
    )],
    ({imgs}) => ImageGalleryPanel({
        imgs,
        hideThumbnails,
        maxWidth,
    }),
);

